import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import QRCodeStyling from 'qr-code-styling';
import { GetParamObject } from '../../util/util';

export const QrPage = (props: { match: any; location: any }) => {
  const [isLoaded, setLoaded] = useState(false);
  const ref: any = useRef(null);

  var query = GetParamObject(props.location.search);

  if (props?.match?.params?.id) {
    useEffect(() => {
      async function getData(params: any) {
        try {
          if (params?.id) {
            const req = await fetch('/qrcode?id=' + params.id, {
              method: 'GET',
              headers: { 'content-type': 'application/json' },
            });

            const json = await req.json();

            if (json) {
              if (json?.data?.style) {
                if (params?.width > 0) json.data.style.width = params.width;

                if (params?.height > 0) json.data.style.height = params.height;
              }

              await AppendStyleData(json, params.download);
            }
          } else {
            throw 'Parameter is not valid!';
          }
        } catch {
          setLoaded(true);
        }
      }

      async function AppendStyleData(json: any, download: any) {
        if (json && json?.data?.url && json?.data?.style) {
          const qrdata = new QRCodeStyling(json.data.style);
          if (qrdata) {
            setLoaded(true);
            qrdata.append(ref.current);
            qrdata.update({ data: json.data.url });

            if (download == true) {
              qrdata.download({
                extension: 'png',
              });
            }
          }
        }
      }

      try {
        const params = {
          id: props.match.params.id,
          width: query?.width && !isNaN(query.width) ? Number(query.width) : 0,
          height:
            query?.height && !isNaN(query.height) ? Number(query.height) : 0,
          download: query?.download ? query.download == 'true' : false,
        };

        if (params.width > 0 && params.height < 1) {
          params.height = params.width;
        }

        if (params.width < 1 && params.height > 0) {
          params.width = params.height;
        }

        getData(params);
      } catch {}
    }, []);
  } else {
  }

  return <> {!isLoaded ? null : <div ref={ref} />}</>;
};
